import React, { useEffect, useRef } from 'react'

interface Props {
    svg: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
    isActive: boolean
}

function HRMSicon(props: Props) {
    const { svg: SVG, isActive } = props
    const svgRef = useRef(null);
    useEffect(() => {
        if (svgRef && svgRef.current != null) {
            const ele: any = svgRef.current
            if (ele.children) {
                const list = ele.children
                for (let item of list) {
                    if (item.getAttribute('stroke')) {
                        ele.setAttribute('fill', 'none')
                        item.setAttribute('stroke', isActive ? '#fff' : '#000')
                    } else if (item.getAttribute('fill')) {
                        item.setAttribute('fill', isActive ? '#fff' : '#000')
                    } else {
                        item.setAttribute('stroke', isActive ? '#fff' : '#000')
                        ele.setAttribute('fill', isActive ? '#fff' : '#000')
                    }
                }
            }
        }
        return () => {

        };
    }, [isActive])

    return (
        <SVG ref={svgRef} />
    )
}

export default HRMSicon
